<template>
    <div style="height: 100%">
           <Button type="primary"  @click.prevent="addColorType">
               <Icon type="md-add"  title="添加类别" />
           </Button>
            <div class="overflowRightNavs" style="margin-top: 20px">
                <section class="group_item" v-for="(k,v) in colorGroupType" :key="v" >
                    <strong class="major finger">{{k.category}}</strong>
                    <ButtonGroup size="small" shape="circle" style="margin-left: 15px">
                        <Button type="primary"  v-if="k.classifyid!=1" @click="editGroupName(k.classifyid,k.category)" title="编辑"><Icon type="ios-create-outline" /></Button>
                        <Button type="primary" v-if="k.classifyid!=1"  @click="delColorType(k.classifyid)"  title="删除">  <Icon type="ios-trash-outline" /></Button>
                    </ButtonGroup>
                    <div style="margin-top: 20px;">
                        <template v-for="(m,n) in k.colorList">
                            <Tag v-if="m.cid==0"  type="border"  >{{ m.name }}</Tag>
                            <Tag closable v-else  type="border"   @on-close="delThatColor(m.id)">{{ m.name }}</Tag>
                        </template>
                        <Button icon="ios-add" size="small" type="primary" @click="handleAdd(k.classifyid)" style="margin-left: 15px" title="添加"></Button>
                    </div>
                </section>
            </div>
    </div>
</template>
<script>
    export default {
        components: {},
        data() {
            return {
                cid: "",
                colorGroupType:[],
                groupName:'',
                colorName:'',
            }
        },
        mounted: function () {
            //DOM更新完后再请求数据
            this.$nextTick(function () {});
        },
        created: function () {
            //DOM更新完之前请求数据
            let data= JSON.parse(localStorage.getItem('adminUser'))
            this.cid=data.cid
            this.getColorCategory(this.cid)
        },
        methods: {
            getColorCategory(cid){
                let data = {
                    cid: cid,
                };
                this.$Api.getColorCategory(data).then(res => {
                    if(res.code==200){
                        this.colorGroupType = res.data
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },

            //添加颜色组
            addColorType(){

                var _this= this
                this.$Modal.confirm({
                    title: '新增颜色组',
                    closable: true,
                    loading: true,
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.value,
                                autofocus: true,
                                placeholder: '请输入组名'
                            },
                            on: {
                                input: (val) => {
                                    _this.groupName = val;
                                }
                            },
                        })
                    },
                    onOk: () => {
                        _this.addColorCategory(_this.cid)
                    },
                })
            },
            //添加颜色
            handleAdd (id) {
                var _this= this
                this.$Modal.confirm({
                    title: '新增颜色',
                    closable: true,
                    loading: true,
                    render: (h) => {
                        return h('Input', {
                            props: {
                                value: this.value,
                                autofocus: true,
                                placeholder: '新增颜色'
                            },
                            on: {
                                input: (val) => {
                                    _this.colorName = val;
                                }
                            },
                        })
                    },
                    onOk: () => {
                          _this.addColor(id)
                    },
                })
            },
            //添加颜色
            addColor(id){
                let data = {
                    cid: this.cid,
                    name: this.colorName,
                    classifyid:id
                };
                this.$Api.addColor(data).then(res => {
                    if(res.code==200){
                        this.$Message.success('添加成功');
                        this.$Modal.remove()
                        this.getColorCategory(this.cid)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //添加颜色分组
            addColorCategory(cid){
                this.$Api.addColorCategory({
                    cid: cid,
                    name: this.groupName
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('添加成功');
                        this.$Modal.remove()
                        this.getColorCategory(this.cid)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //修改颜色分组
            editColorCategory(id,name){
                this.$Api.upColorCategory({
                    cid: this.cid,
                    name: name,
                    id: id
                }).then(res => {
                    if(res.code==200){
                        this.$Message.success('修改成功');
                        this.$Modal.remove()
                        this.getColorCategory(this.cid)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //修改颜色组名字
            editGroupName(id,name){

                this.$Modal.confirm({
                        title: '修改颜色组名称',
                        closable: true,
                        loading: true,
                        render: (h) => {
                            return h('Input', {
                                props: {
                                    value: name,
                                    autofocus: true,
                                },
                                on: {
                                    input: (val) => {
                                        this.colorName = val;
                                    }
                                },
                            })
                        },
                        onOk: () => {
                          this.editColorCategory(id,this.colorName)
                        },

                })
            },
            //删除颜色
            delThatColor (id){
                var _this = this
                this.$Modal.confirm({
                    title: '提示信息',
                    content: '您确认删除此颜色吗？',
                    loading: true,
                    onOk:() =>{
                        _this.$Api.delColor({
                            id: id
                        }).then(res => {
                            if(res.code==200){
                                this.$Message.success('删除成功');
                                this.$Modal.remove()
                                this.getColorCategory(this.cid)
                            }else {
                                this.$Message.warning(res.msg);
                            }
                        });

                    }
                });
            },

            delColorType(id){
                this.$Modal.confirm({
                    title: '提示信息',
                    content: '您确认删除此颜色分组吗？',
                    loading: true,
                    onOk:() =>{
                        this.$Api.delColorCategory({
                            id: id
                        }).then(res => {
                            if(res.code==200){
                                this.$Message.success('删除成功');
                                this.$Modal.remove()
                                this.getColorCategory(this.cid)
                            }else {
                                this.$Message.warning(res.msg);
                            }
                        });

                    }
                });
            },
        }
    }
</script>


<style lang="scss" scoped>
    .server-title {
        display: inline-block;
        text-align: center;
        width: 88%
    }
.group_item{
    margin-bottom: 50px;
}

.overflowRightNavs{
    position: fixed;
    height: 60%;
    padding: 0px 0 300px;
    overflow: auto;
}
</style>